import Client from '@/clients/apiClient';
import humps from 'humps';
import { stringify } from 'query-string';

const resource = 'officers';

export default {
  get() {
    return Client.get(`/${resource}`);
  },
  getSelf(id) {
    return Client.get(`/${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`/${resource}`, payload);
  },
  update(id, payload) {
    return Client.put(`/${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`/${resource}/${id}`);
  },
  getPerformances(payload) {
    return Client.get(
      `/officer-performances?page=${payload.page}&limit=${
        payload.perPage
      }&sort[field]=${humps.decamelize(payload.sort.field)}&sort[type]=${
        payload.sort.type
      }&${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
};
